import { axios } from '@/utils/http'

export default {
  // # region 财私部
  // 保存调查问卷信息
  saveSurvey(data) {
    return axios({
      url: '/hx/surveydata/save',
      method: 'post',
      data
    })
  },
  // # endregion  财私部

  // # region 个人部
  // 根据分组编码获取主页链接
  getLinksByGroupCode(groupCode) {
    return axios({
      url: '/hx/link/listbygroupcode',
      method: 'get',
      params: {
        groupCode
      }
    })
  },
  // 登录
  userlogin(params) {
    return axios({
      url: '/hx/userlogin',
      method: 'get',
      params
    })
  },
  // 获取产品列表
  getProductList(params) {
    return axios({
      url: '/hx/product/list',
      method: 'get',
      params
    })
  },
  // 获取产品详情
  getProductDetail(params) {
    return axios({
      url: '/hx/product/getById',
      method: 'get',
      params
    })
  },
  // 下单
  place(params) {
    return axios({
      url: '/hx/order/place',
      method: 'post',
      data: params
    })
  },
  // 获取订单详情
  getOrderDetail(params) {
    return axios({
      url: '/hx/order/find',
      method: 'get',
      params
    })
  },
  // 判断用户是否有参与某活动的权益
  isHaveRight(params) {
    return axios({
      url: '/hx/order/isHaveRight',
      method: 'get',
      params
    })
  },
  // 查询订单列表
  getOrderList(params) {
    return axios({
      url: '/hx/order/list',
      method: 'get',
      params
    })
  },
  // 获得验证码
  getSmsCode(params) {
    return axios({
      url: '/hx/order/sendCode',
      method: 'get',
      params
    })
  },
  // 充值，用于直充类型商品
  // /hx/order/bind
  recharge(params) {
    return axios({
      url: '/hx/order/bind',
      method: 'post',
      data: params
    })
  },
  fetchOpenid(params) {
    return axios({
      url: 'hx/order/getopenid',
      method: 'get',
      params
    })
  },

  // 微信预支付
  wxPrePay(params) {
    return axios({
      url: '/hx/order/wxpay',
      method: 'post',
      data: params
    })
  },
  // 获得微信签名
  getWxSignature(params) {
    return axios({
      url: '/hx/order/getsignature',
      method: 'get',
      params
    })
  },
  // 取消支付
  cancelPay(params) {
    return axios({
      url: '/hx/order/cancel',
      method: 'post',
      data: params
    })
  },

  // # endregion 个人部

  // # region 财私部

  // 用户积分查询
  getPoints(params) {
    return axios({
      url: '/hx/points',
      method: 'get',
      params
    })
  },

  // 用户积分列表
  getPointsDetail() {
    return axios({
      url: '/hx/pointslist',
      method: 'get'
    })
  },

  // # endregion 财私部
}
